import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";

import Imagen1 from "../../../images/modulo13/andenes.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo13/Unidad1Actividad5.mp3";

const Actividad7 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "territorio" },
    ans2: { value: "", valid: "", correctValue: "relieve" },
    ans3: { value: "", valid: "", correctValue: "clima" },
  });
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[5];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[6].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[6].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[4].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };
  const handleAnswers = (event, name) => {
    event.preventDefault();
    setAnswers({
      ...answers,
      [name]: { ...answers[name], value: event.target.value },
    });
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo13.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <ul>
        <li>Completa el siguiente texto con estas palabras.</li>
      </ul>

      <div className="row justify-content-center">
      <div className="col-lg-10 col-12">
          <Card>
            <div className="d-flex justify-content-around">
              <div>territorio</div>
              <div>relieve</div>
              <div>clima</div>
            </div>
          </Card>
        </div>
      </div>

      <div className="w-100 text-center mb-4">
        <img src={Imagen1} alt="Anuncio" className="img-fluid" />
      </div>

      <div className="row justify-content-center">
        
        <div className="col-lg-10 col-12">
          <p className="fs-5">
            Los incas hemos tenido que resolver los problemas que nos planteaba
            nuestro{" "}
            <input
              type="text"
              className={
                "form-control form-control-sm w-200 d-inline-block " +
                answers.ans1.valid
              }
              value={answers.ans1.value}
              onChange={(event) => handleAnswers(event, "ans1")}
            />{" "}
            . El{" "}
            <input
              type="text"
              className={
                "form-control form-control-sm w-200 d-inline-block " +
                answers.ans2.valid
              }
              value={answers.ans2.value}
              onChange={(event) => handleAnswers(event, "ans2")}
            />{" "}
            es muy accidentado y por eso construimos andenes para poder sembrar.
            Teníamos también grandes almacenes para guardar las cosechas y
            cuidarlas de los cambios de{" "}
            <input
              type="text"
              className={
                "form-control form-control-sm w-200 d-inline-block " +
                answers.ans3.valid
              }
              value={answers.ans3.value}
              onChange={(event) => handleAnswers(event, "ans3")}
            />{" "}
            como la granizada o las lluvias.
          </p>
        </div>
      </div>

      <div className="row my-4">
        <div className="col-lg-11 col-12">
          <button
            className={`btn float-end btn-${modulo13.color}`}
            onClick={validateAnswers}
          >
            Enviar respuestas
          </button>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea la primera indicación: Completa el siguiente texto con estas
          palabras: territorio – relieve – clima. Pida que
          lean en silencio el texto. Déles un tiempo para trabajar y luego
          revise de manera conjunta el párrafo.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad7;
